import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	chatIntegrationNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.chat-integration-non-final',
		defaultMessage: 'Chat integration',
		description: 'Transition home chat tools step copy integration table integration name head',
	},
	connectedToNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.connected-to-non-final',
		defaultMessage: 'Connected to',
		description: 'Transition home chat tools step copy integration table connected to head',
	},
	responderTeamNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.responder-team-non-final',
		defaultMessage: 'Responder team',
		description: 'Transition home chat tools step copy integration table responder team head',
	},
	statusNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.status-non-final',
		defaultMessage: 'Status',
		description: 'Transition home chat tools step copy integration table status head',
	},
});
